<template>
    <div class="row">
        <!-- SCREEN 1 -->
        <div class="col-12 mb-4">
          <button
            type="submit"
            class="btn btn-orange bg-orange text-white lh-1 text-uppercase text-uppercase text-lg"
            v-if="isLocationSpeq"
          >
            Standard
          </button>
          <button
            type="submit"
            class="ml-2 btn bg-light text-gray border-gray lh-1 text-uppercase text-uppercase text-lg"
            v-if="isLocationSpeq"
            @click="goToSpeqOrderCreate(currentLocation, selectedLocation)"
          >
            SPEQ
          </button>
        </div>
        <div v-if="screen == 1" class="col-sm-12 col-md-8">
            <h3 class="mb-0">Create an Order</h3>
            <p>
                Add items by SKU or search using product name or feature. Can't
                find what you need? <u>Contact your representative.</u>
            </p>
            <div
                class="alert alert-danger"
                role="alert"
                v-if="showPaymentError"
            >
                Unable to process your payment, please contact the site
                administrator.
            </div>
            <div class="row">
                <div class="col-md-4">
                    <label class="text-muted">PO Number</label>
                    <input
                        @keyup="savePO"
                        type="text"
                        class="form-control"
                        v-model="po_number"
                        placeholder="Input PO Number"
                        autocomplete="off"
                        :class="{
                            'is-invalid': submitted && v$.po_number.$error,
                        }"
                    />
                    <!-- <span class="text-danger" v-if="v$.po_number.$errors">
                        {{ v$.po_number.$errors[0]?.$message }}
                    </span> -->
                    <span class="text-danger" v-if="po_number.length > 20">
                        The maximum length allowed is 20 characters
                    </span>
                </div>
                <div class="col-md-6 position-relative">
                    <div v-if="currentLocation.id == 0" >
                        <label class="text-muted">Location</label>
                        <select
                            class="form-control"
                            @change="selectLocation"
                            v-model="selectedLocation"
                            :class="{
                                'is-invalid':
                                    submitted && v$.selectedLocation.$error,
                            }"
                        >
                            <option :value="null">Select Location</option>
                            <template v-for="(loc, idx) in locations" :key="idx">
                                <option :value="loc">
                                    {{ loc.name }} - {{ loc.address }},
                                    {{ loc.city }}, {{ loc.state }},
                                    {{ loc.zip_code }}
                                </option>
                            </template>
                        </select>
                        <span
                            class="text-danger"
                            v-if="v$.selectedLocation.$errors"
                        >
                            {{ v$.selectedLocation.$errors[0]?.$message }}
                        </span>
                    </div>

                    <div class="free-shipping-section"
                        v-if="currentLocation.id != 0"
                    >
                        <div v-if="hasShippingFee">
                            <strong>How to get free shipping</strong>
                            <p>
                                To qualify for Free Shipping, each order must meet
                                one of the following conditions:
                            </p>
                            <ul>
                                <li>
                                    ${{
                                        $filters.moneyFormatWhole(
                                            suppressor_free_shipping_amount
                                        )
                                    }}+ in suppressors
                                </li>
                                <li>
                                    <strong>OR </strong> ${{
                                        $filters.moneyFormatWhole(
                                            accessory_free_shipping_amount
                                        )
                                    }}+ in accessories
                                </li>
                                <li>
                                    <strong>OR </strong>${{
                                        $filters.moneyFormatWhole(
                                            combined_free_shipping_amount
                                        )
                                    }}+ combined total
                                </li>
                            </ul>
                        </div>

                        <div v-if="hasFFLExpired"> 
                            <strong>Your FFL expired on {{ formattedFFLExpiryDate }}</strong>
                            <p>Please send an updated copy to <a href="mailto:dealerupdate@silencerco.com">dealerupdate@silencerco.com</a>.</p>
                            <p>Turnaround time is typically 24–48 business hours. <br/>
                                Until our system is updated, serialized items will not be available for purchase.</p>
                        </div>
                    </div>                    
                </div>                
            </div>
            <div class="row mt-3">
                <div class="col-md-4">
                    <label class="text-muted">Attach PO (PDF)</label>
                    <input
                        type="file"
                        name="thumbnail"
                        @change="onChangeThumbnail"
                        class="form-control"
                        accept=".pdf"
                        required
                        autofocus
                    />
                </div>
                <div class="text-danger" v-if="showPoAttachError">
                    PO Attachment is required
                </div>

                <!-- <div class="col-md-4">
                    <div class="preview-container mt-4" v-if="thumbnail.length">
                        <div
                            v-for="file in thumbnail"
                            :key="file.name"
                            class="preview-card"
                        >
                            <img
                                class="preview-img3"
                                style="height: 10ch; width: auto"
                                :src="generateURL(file)"
                            />
                        </div>
                    </div>
                </div> -->
            </div>
            <div class="row mt-3">
                <div class="col-md-4">
                    <label class="text-muted">Requested Delivery Date</label>
                    <datepicker
                        class="form-control"
                        v-model="requestedDeliveryDate"
                        :lower-limit="lowerLimit"
                    />
                </div>
                <div class="text-danger" v-if="showDateError">
                    Delivery date is required
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <div class="free-shipping-section alt"
                    v-if="currentLocation.id == 0"
                    >
                        <div v-if=" hasShippingFee">
                    
                            <strong>How to get free shipping</strong>
                            <p>
                                To qualify for Free Shipping, each order must meet
                                one of the following conditions:
                            </p>
                            <ul>
                                <li>
                                    ${{
                                        $filters.moneyFormatWhole(
                                            suppressor_free_shipping_amount
                                        )
                                    }}+ in suppressors
                                </li>
                                <li>
                                    <strong>OR </strong> ${{
                                        $filters.moneyFormatWhole(
                                            accessory_free_shipping_amount
                                        )
                                    }}+ in accessories
                                </li>
                                <li>
                                    <strong>OR </strong>${{
                                        $filters.moneyFormatWhole(
                                            combined_free_shipping_amount
                                        )
                                    }}+ combined total
                                </li>
                            </ul>
                        </div>   
                        
                        <div v-if="hasFFLExpired"> 
                            <strong>Your FFL expired on {{ formattedFFLExpiryDate }}</strong>
                            <p>Please send an updated copy to <a href="mailto:dealerupdate@silencerco.com">dealerupdate@silencerco.com</a>.</p>
                            <p>Turnaround time is typically 24–48 business hours. <br/>
                                Until our system is updated, serialized items will not be available for purchase.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-3" v-if="(currentLocation.id != 0 || selectedLocation) && dealerPriceLists.length >= 1">
                <div class="col-md-6 pb-2">
                    <div class="form-group">
                        <label class="text-muted">PRICELIST</label>
                        <div class="input-group search-field">
                            <select
                                class="form-control mb-1"
                                v-model="selectedPriceList"
                                @change="changePriceList"
                            >
                                <option
                                    v-for="(
                                        dealerPriceList, index
                                    ) in dealerPriceLists"
                                    :key="index"
                                    :value="dealerPriceList.id"
                                >
                                    {{ dealerPriceList.pricelist_name }}
                                    <span
                                        v-if="
                                            dealerPriceList.buy_group_dates_id
                                        "
                                    >
                                        ({{
                                            $filters.dateFormat(
                                                dealerPriceList.buy_group_dates_start_date
                                            )
                                        }}
                                        -
                                        {{
                                            $filters.dateFormat(
                                                dealerPriceList.buy_group_dates_end_date
                                            )
                                        }})
                                    </span>
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-md-6 pb-2">
                    <div class="form-group">
                        <label class="text-muted">SEARCH</label>
                        <div class="input-group search-field">
                            <input
                                type="text"
                                class="form-control"
                                v-model="searchTerm"
                                placeholder="Search the store"
                                autocomplete="off"
                            />
                            <div class="input-group-prepend">
                                <span class="input-group-text"
                                    ><i class="fas fa-search"></i
                                ></span>
                            </div>
                        </div>
                    </div>
                    <ul
                        class="search-results"
                        v-if="searchPricelistsbyTerm.length"
                    >
                        <li
                            v-for="prod in searchPricelistsbyTerm"
                            :key="prod.id"
                            @click="selectProduct(prod, 'term')"
                        >
                            <div class="row">
                                <div class="col-md-8">
                                    <span class="sku">{{ prod.sku }}</span>
                                    <span class="product-name">{{
                                        prod.product_name
                                    }}</span>
                                </div>
                                <div class="col-md-4 text-right">
                                    <span class="price"
                                        >${{
                                            $filters.moneyFormat(prod.price)
                                        }}</span
                                    >
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div id="misc_errors">
                <div class="row" v-if="miscErrors.length > 0">
                    <div
                        class="alert alert-danger my-1 col-md-12"
                        role="alert"
                        v-for="(err, index) in miscErrors"
                        :key="index"
                    >
                        {{ err }}
                    </div>
                </div>
            </div>

            <div class="row mt-3">
                <div class="col-md-12">
                    <table v-if="!isMobile" class="table table-responsive orders">
                        <thead>
                            <tr>
                                <th style="width: 5em">SKU</th>
                                <th>Product Name</th>
                                <th style="width: 11em" class="text-center">
                                    Stock Available
                                </th>
                                <th style="width: 11em" class="text-center">
                                    Quantity
                                </th>
                                <th style="width: 10em" class="text-right">
                                    Unit Price
                                </th>
                                <th style="width: 10em" class="text-right">
                                    Subtotal
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(order, idx) in orders" :key="order.id">
                                <td>{{ order.sku }}</td>
                                <td>
                                    <b>{{ order.product_name }}</b>
                                </td>
                                <td class="text-center">
                                    {{ order.available_quantity }}
                                </td>
                                <td class="mobile-text-right">
                                    <div
                                        class="quantity-toggle d-flex align-items-center"
                                    >
                                      <span class="mr-1 text-muted quantity-note">Min {{ minimumQuantity }}</span>
                                      <input
                                        type="number"
                                        class="form-control border w-100"
                                        :min="minimumQuantity"
                                        @change="calculate(idx)"
                                        @input="validateAndUpdateQuantity($event, idx)"
                                        v-model="order.quantity"
                                      />
                                      <div
                                          class="cursor-pointer pl-3"
                                          @click="removeItem(idx)"
                                      >
                                          <i
                                              class="fa fa-times"
                                              aria-hidden="true"
                                          ></i>
                                      </div>
                                    </div>
                                </td>
                                <td class="text-right">
                                    <b
                                        >${{
                                            $filters.moneyFormat(
                                                order.unit_cost
                                            )
                                        }}</b
                                    >
                                </td>
                                <td class="text-right">
                                    <b v-if="order.quantity > 0"
                                        >${{
                                            $filters.moneyFormat(
                                                order.sub_total
                                            )
                                        }}
                                    </b>
                                    <b v-else> $0.00 </b>
                                </td>
                            </tr>
                            <!-- <tr
                                v-if="
                                    orders?.length > 0 &&
                                    ((currentLocation.id != 0 &&
                                        currentLocation.prepay == 1) ||
                                        (currentLocation.id == 0 &&
                                            selectedLocation?.prepay == 1))
                                "
                            > -->
                            <tr v-if="orders?.length > 0">
                                <td class="border-0" colspan="3">&nbsp;</td>
                                <td
                                    class="subtotal text-right"
                                    colspan="3"
                                    v-if="hasShippingFee"
                                >
                                    <label class="pr-3">SHIPPING FEE</label>
                                    <span class="h6"
                                        >${{
                                            $filters.moneyFormat(shippingFee)
                                        }}</span
                                    >
                                </td>
                            </tr>
                            <tr v-if="orders?.length > 0">
                                <td class="border-0" colspan="3">&nbsp;</td>
                                <td class="subtotal">
                                    <label>Total Items</label>
                                    <b class="pl-3">{{ totalQuantity }}</b>
                                </td>
                                <td class="subtotal text-right" colspan="2">
                                    <label class="pr-3">GRAND TOTAL</label>
                                    <span class="h6"
                                        >${{
                                            $filters.moneyFormat(
                                                grandTotal
                                            )
                                        }}</span
                                    >
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div v-else class="mobile-orders">
                      <mobile-orders-card
                        v-for="(order, idx) in orders"
                        :key="order.id"
                        :order="order"
                        @remove-item="removeItem(idx)"
                        @calculate="calculate(idx)"
                        @update-quantity="(event) => validateAndUpdateQuantity(event, idx)"
                      />

                      <!-- Order Summary Card -->
                      <mobile-order-summary
                        v-if="orders?.length > 0"
                        :has-shipping-fee="hasShippingFee"
                        :shipping-fee="shippingFee"
                        :total-quantity="totalQuantity"
                        :total-amount="(grandTotal)"
                      />
                    </div>
                </div>
            </div>
            <div class="row mt-5">
                <div class="col-md-8"></div>
                <div class="col-md-4">
                    <button
                        @click="handleSubmit"
                        type="submit"
                        class="btn btn-outline-orange text-orange text-uppercase float-end w-100"
                        :class="reviewOrder()"
                    >
                        Review Order
                    </button>
                </div>
            </div>
        </div>
        <!-- SCREEN 2 : REVIEW ORDER -->
        <div v-else-if="screen == 2" class="col-sm-12 col-md-8">
            <h3 class="mb-0">Review Your Order</h3>
            <div class="row mt-4">
                <div class="col-md-12">
                    <div class="d-flex align-items-center py-2">
                        <label class="pr-3">PO Number: </label>
                        <h5>{{ po_number }}</h5>
                    </div>

                    <table v-if="!isMobile" class="table table-responsive orders">
                        <thead>
                            <tr>
                                <th style="width: 5em">SKU</th>
                                <th>Product Name</th>
                                <th style="width: 11em" class="text-center">
                                    Stock Available
                                </th>
                                <th style="width: 11em" class="text-right">
                                    Quantity
                                </th>
                                <th style="width: 10em" class="text-right">
                                    Unit Price
                                </th>
                                <th style="width: 10em" class="text-right">
                                    Subtotal
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="order in orders" :key="order.id">
                                <tr v-if="order.quantity > 0">
                                    <td>{{ order.sku }}</td>
                                    <td>
                                        <b>{{ order.product_name }}</b>
                                    </td>
                                    <td class="text-center">
                                        {{ order.available_quantity }}
                                    </td>
                                    <td class="text-right">
                                        <b>{{ order.quantity }}</b>
                                    </td>
                                    <td class="text-right">
                                        <b
                                            >${{
                                                $filters.moneyFormat(
                                                    order.unit_cost
                                                )
                                            }}</b
                                        >
                                    </td>
                                    <td class="text-right">
                                        <b v-if="order.quantity > 0"
                                            >${{
                                                $filters.moneyFormat(
                                                    order.sub_total
                                                )
                                            }}
                                        </b>
                                        <b v-else> $0.00 </b>
                                    </td>
                                </tr>
                            </template>
                            <tr v-if="orders?.length > 0">
                                <td class="border-0" colspan="3">&nbsp;</td>
                                <td
                                    class="subtotal text-right"
                                    colspan="3"
                                    v-if="hasShippingFee"
                                >
                                    <label class="pr-3">SHIPPING FEE</label>
                                    <span class="h6"
                                        >${{
                                            $filters.moneyFormat(shippingFee)
                                        }}</span
                                    >
                                </td>
                            </tr>
                            <tr v-if="orders?.length > 0">
                                <td class="border-0" colspan="3">&nbsp;</td>
                                <td class="subtotal text-right">
                                    <label>Total Items</label>
                                    <b class="pl-3">{{ totalQuantity }}</b>
                                </td>
                                <td class="subtotal text-right" colspan="2">
                                    <label class="pr-3">GRAND TOTAL</label>
                                    <span class="h6"
                                        >${{
                                            $filters.moneyFormat(
                                                grandTotal
                                            )
                                        }}</span
                                    >
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div v-else class="mobile-orders">
                      <mobile-orders-card
                        v-for="(order, idx) in orders"
                        :key="order.id"
                        :order="order"
                        :is-summary="true"
                      />

                      <!-- Order Summary Card -->
                      <mobile-order-summary
                        v-if="orders?.length > 0"
                        :has-shipping-fee="hasShippingFee"
                        :shipping-fee="shippingFee"
                        :total-quantity="totalQuantity"
                        :total-amount="(grandTotal)"
                      />
                    </div>
                </div>
            </div>
            <!-- <div
                class="row mt-5 submit-order-button"
                v-if="
                    (currentLocation.id != 0 && currentLocation.prepay == 0) ||
                    (currentLocation.id == 0 && selectedLocation?.prepay == 0)
                "
            > -->
            <div class="row mt-5 submit-order-button">
                <div class="col-md-6"></div>
                <div class="col-md-2">
                    <button
                        @click="screen = 1"
                        type="submit"
                        class="btn btn-outline-secondary text-uppercase float-end w-100"
                    >
                        Go back
                    </button>
                </div>
                <div class="col-md-4">
                    <button
                        @click="saveOrder"
                        type="submit"
                        class="btn btn-outline-danger text-uppercase float-end w-100"
                    >
                        Submit Order
                    </button>
                </div>
            </div>
        </div>
        <!-- SCREEN 3 : THANK MESSAGE -->
        <div v-else class="col-sm-12 col-md-8">
            <h3 class="mb-4">Thanks!</h3>
            <!-- <p>We've received your order <b>#{{ orderId }}</b>. We'll notify you as soon as it ships.</p>
            <p>You can always check the status of your purchases on <span>Order History</span>.</p> -->
            <p>
                We have received your order and your sales rep has been
                notified. Please continue to check your dealer portal for
                updates.
            </p>
            <div class="row mt-5">
                <div class="col-md-4">
                    <button
                        @click="backToDashboard"
                        type="submit"
                        class="btn btn-outline-danger text-uppercase float-end w-100"
                    >
                        Back to Dashboard
                    </button>
                </div>
            </div>
        </div>
        <!-- PAYMENT HANDLER -->
        <!-- <div v-show="screen == 2">
            <div class="col-sm-12 col-md-8">
                <div class="row mt-5 submit-order-button">
                    <div class="col-md-6"></div>
                    <div class="col-md-2">
                        <button
                            @click="screen = 1"
                            type="submit"
                            class="btn btn-outline-secondary text-uppercase float-end w-100"
                        >
                            Go back
                        </button>
                    </div>
                    <div class="col-md-4">
                        <button
                            type="submit"
                            class="btn btn-outline-danger text-uppercase float-end w-100 AcceptUI"
                            data-billingAddressOptions='{"show":true, "required":false}'
                            :data-apiLoginID="authorizeLoginId"
                            :data-clientKey="authorizeClientKey"
                            data-acceptUIFormBtnTxt="Submit"
                            data-acceptUIFormHeaderTxt="Payment Options"
                            data-paymentOptions='{"showCreditCard": true, "showBankAccount": true}'
                            data-responseHandler="responseHandler"
                            id="paymentButton"
                            data-show="inline"
                            
                        >
                            Pay Order
                        </button>
                    </div>
                </div>
            </div>
        </div> -->
        
        <b-modal
            v-model="showPaymentModal"
            title="Payment Options"
            class="mt-5"
            hide-footer
        >
            <PaymentOptions
                v-if="showPaymentModal"
                :grossTotal="grandTotal"
                @close-modal="closePaymentModal"
                @success="(e) => saveOrder(e)"
            />
        </b-modal>
    </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore, mapActions } from "vuex";
import { useVuelidate } from "@vuelidate/core";
import {
    required,
    email,
    minLength,
    sameAs,
    requiredIf,
    maxLength,
} from "@vuelidate/validators";
import MobileOrderSummary from "./MobileOrderSummary.vue";
import MobileOrdersCard from "./MobileOrdersCard.vue";
import PaymentOptions from './PaymentOptions.vue';
import { useOrderToggle } from "../../composables/useOrderToggle";
import moment from 'moment';

export default {
    props: [],
    emits: [],
    components: {
      MobileOrderSummary,
      MobileOrdersCard,
      PaymentOptions
    },
    setup() {
        const store = useStore();

        let pricelists = computed(function () {
            return store.state.pricelists;
        });
        let dealerPriceLists = computed(function () {
            return store.state.dealerPriceLists;
        });
        let user = computed(function () {
            return store.state.user;
        });
        let orderId = computed(function () {
            return store.state.orderId;
        });
        let currentLocation = computed(function () {
            return store.state.currentLocation;
        });
        let locations = computed(function () {
            return store.state.locations;
        });
        let selectedStatePriceList = computed(function () {
            return store.state.selectedStatePriceList;
        });

        function getAllPricelists(currentLocation) {
            store.dispatch("getAllPricelists", {
                pricelist_id: currentLocation.pricelist_id,
                location_id: currentLocation.id,
            });
        }

        function submitOrder(form) {
            store.dispatch("submitOrder", form);
        }

        function getLocations(userId) {
            store.dispatch("getLocations", { user_id: userId });
        }

        function getDealerPriceLists(currentLocationId) {
            store.dispatch("getDealerPriceLists", {
                location_id: currentLocationId,
            });
        }

        const { goToSpeqOrderCreate } = useOrderToggle();

        const defaultMinimumQuantity = computed(() => store.getters.getOrderDefaultMinimumQuantity);

        onMounted(async () => {
          await store.dispatch('getMinimumQuantity');
        });
        const hasFFLExpired = computed(() => {            
            if( moment(currentLocation.value.ffl_expiry_date).isBefore(moment(), 'day') ){
                return true;
            } else {
                return false;
            }
        });

        const formattedFFLExpiryDate = computed(() => {
            return moment(currentLocation.value.ffl_expiry_date).format('MMM DD, YYYY');
        });


        return {
            store,
            pricelists,
            dealerPriceLists,
            user,
            orderId,
            currentLocation,
            locations,
            selectedStatePriceList,
            submitOrder,
            getAllPricelists,
            getLocations,
            getDealerPriceLists,
            goToSpeqOrderCreate,
            defaultMinimumQuantity,
            hasFFLExpired,
            formattedFFLExpiryDate,
        };
    },
    data() {
        return {
            v$: useVuelidate(),
            searchSKU: "",
            searchTerm: "",
            orders: JSON.parse(localStorage.getItem("orders")),
            screen: 1,
            po_number: localStorage.getItem("po_number"),
            selectedLocation: null,
            submitted: false,
            thumbnail: [],
            miscErrors: [],
            requestedDeliveryDate: null,
            lowerLimit: new Date(),
            showPaymentForm: false,
            paymentData: null,
            showPaymentError: false,
            authorizeLoginId: process.env.MIX_AUTHORIZE_MERCHANT_LOGIN_ID,
            authorizeClientKey: process.env.MIX_AUTHORIZE_PUBLIC_CLIENT_KEY,
            paymentInProgress: false,
            showPoAttachError: false,
            showDateError: false,
            selectedPriceList: null,
            suppressor_free_shipping_amount: 750,
            combined_free_shipping_amount: 1000,
            accessory_free_shipping_amount: 350,
            showPaymentModal: false,
            grossTotal: 0,
        };
    },
    validations() {
        return {
            po_number: { required, maxLength: maxLength(20) },
            selectedLocation: {
                required: requiredIf(function () {
                    return this.currentLocation.id == 0;
                }),
            },
        };
    },
    computed: {
        minimumQuantity() { 
          if (this.currentLocation && this.currentLocation.id !== 0 && this.currentLocation.order_minimum_quantity) {
            return this.currentLocation.order_minimum_quantity;
          }

          if (this.selectedLocation && this.selectedLocation.order_minimum_quantity) {
            return this.selectLocation.order_minimum_quantity;
          }

          return this.defaultMinimumQuantity;
        },
        isMobile() {
          return window.innerWidth <= 768;
        },
        shippingFee() {
            // if (this.currentLocation.prepay == 0) {
            //if (
            //    (this.currentLocation.id != 0 &&
            //        this.currentLocation.prepay == 0) ||
            //    (this.currentLocation.id == 0 &&
            //        this.selectedLocation?.prepay == 0)
            //) {
            //    return 0;
            //}

            if (!this.hasShippingFee) {
                return 0;
            }

            let accessoryTotal = 0;
            let silencerTotal = 0;

            for (let x = 0; x < this.orders.length; x++) {
                if (
                    this.orders[x].sku[0] == "A" &&
                    this.orders[x].sku[1] == "C"
                ) {
                    accessoryTotal += this.orders[x].sub_total;
                } else if (
                    this.orders[x].sku[0] == "S" &&
                    this.orders[x].sku[1] == "U"
                ) {
                    silencerTotal += this.orders[x].sub_total;
                }
            }
            if (
                accessoryTotal >= this.accessory_free_shipping_amount ||
                silencerTotal >= this.suppressor_free_shipping_amount ||
                accessoryTotal + silencerTotal >=
                    this.combined_free_shipping_amount
            ) {
                return 0;
            }
            return 20;
        },
        searchPricelistsbyTerm() {
            if (this.searchTerm === "" || (this.currentLocation.id == 0 && this.selectedLocation == null)) {
                return [];
            }

            // let matches = 0;

            return this.pricelists.filter((prod) => {
                if (
                    prod.product_name
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase()) ||
                    prod.sku
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase())
                    // && matches < 10
                ) {
                    // matches++;
                    return prod;
                }
            });
        },
        totalQuantity() {
            let quantity = 0;
            this.orders.forEach((data, idx) => {
                if (data.quantity > 0) {
                    quantity += data.quantity;
                }
            });
            return quantity;
        },
        totalCost() {
            let sub_total = 0;
            this.orders.forEach((data, idx) => {
                if (data.sub_total > 0) {
                    sub_total += data.sub_total;
                }
            });
            return sub_total;
        },

        grandTotal() {
            return this.totalCost + this.shippingFee;
        },
        totalSuppressorQty() {
            let qty = 0;
            for (let x = 0; x < this.orders.length; x++) {
                if (this.orders[x].sku.includes("SU")) {
                    qty += this.orders[x].quantity;
                }
            }
            return qty;
        },
        totalAccessoryQty() {
            let qty = 0;
            for (let x = 0; x < this.orders.length; x++) {
                if (this.orders[x].sku.includes("AC")) {
                    qty += this.orders[x].quantity;
                }
            }
            return qty;
        },
        hasShippingFee() {
            if (this.currentLocation.id == 0) {
                if (this.selectedLocation != null) {
                    if (
                        this.selectedLocation.is_buy_group_dealer == 1 ||
                        this.selectedLocation.is_premier_dealer == 1
                    ) {
                        return true;
                    }
                }
            }

            if (
                this.currentLocation.is_buy_group_dealer == 1 ||
                this.currentLocation.is_premier_dealer == 1
            ) {
                return true;
            }
            return false;
        },
        isLocationSpeq() {
          return this.currentLocation?.is_speq === 1 || (this.currentLocation?.id == 0 && this.selectedLocation?.is_speq === 1);
        }
    },
    mounted() {
        window.emitter.on("refreshCreateOrderPage", (status) => {
            this.orders = JSON.parse(localStorage.getItem("orders"));
        });

        // console.log(this.currentLocation, "currentLocation");
        // console.log(this.hasShippingFee, "hasShippingFee");
        this.getFreeShippingSettings();
        if (this.selectedStatePriceList != null) {
            this.selectedPriceList = this.selectedStatePriceList;
        } else {
            this.selectedPriceList = this.currentLocation.pricelist_id;
        }
        if (this.user.online_order) {
            this.getDealerPriceLists(this.currentLocation.id);
            this.getAllPricelists(this.currentLocation);
            this.getLocations(this.user.id);
        } else {
            this.$router.push({ name: "dashboard" });
        }


       

        if (this.orders.length > 0) {
            this.changePriceList();
        }

        const locationId = this.$route.query.location_id;

        if (locationId) {
          this.selectedLocation = this.locations.find(location => location.id === parseInt(locationId));
          localStorage.setItem('is_selected_location_speq', this.selectedLocation?.is_speq)

          const url = new URL(window.location.href);
          url.searchParams.delete('location_id');
          window.history.replaceState({}, '', url);
        }
    },
    methods: {
        closePaymentModal() {
            this.showPaymentModal = false;
        },
        handleSubmit(e) {
            e.preventDefault();

            /*
            this.showPoAttachError = false;

            if (this.thumbnail.length <= 0) {
                this.showPoAttachError = true;
                return;
            }*/

            this.showDateError = false;
            if (this.requestedDeliveryDate == null) {
                this.showDateError = true;
                return;
            }

            let hasQuantityError = false;

            this.orders.forEach((order) => {
              if (order.quantity < this.minimumQuantity) {
                hasQuantityError = true;
              }
            });

            if (hasQuantityError) {
              this.miscErrors = [`Minimum quantity per order is ${this.minimumQuantity}`];
              document.getElementById("misc_errors").scrollIntoView();
              return;
            }

            this.v$.$validate();
            if (!this.v$.$error) {

                // buy date validation
                if (!this.buyDateValidation()) {
                    return;
                }

                // if ANY fail validation
                // if (this.currentLocation.prepay == 1) {
                // if (
                //     (this.currentLocation.id != 0 &&
                //         this.currentLocation.prepay == 1) ||
                //     (this.currentLocation.id == 0 &&
                //         this.selectedLocation?.prepay == 1)
                // ) {
                //     this.showPaymentForm = true;
                // }
                // if (this.currentLocation.id == 0) {
                //     return 0;
                // }
                this.submitted = true;

                

                this.screen = 2;
            } else {
                // alert('Form failed validation')
            }
        },
        updateRow(val) {
            this.paginatedOrders = val;
        },
        selectProduct(product, type) {
            let tempOrder = {
                id: product.id,
                sku: product.sku,
                product_name: product.product_name,
                unit_cost: product.price,
                quantity: this.minimumQuantity,
                sub_total: product.price * this.minimumQuantity,
                available_quantity: product.available_quantity,
            };
            this.orders.push(tempOrder);
            type == "sku" ? (this.searchSKU = "") : (this.searchTerm = "");

            localStorage.setItem("orders", JSON.stringify(this.orders));
            this.store.commit("setOrders", this.orders);
        },
        increment(idx) {
            this.orders[idx].quantity++;
            this.orders[idx].sub_total =
                this.orders[idx].unit_cost * this.orders[idx].quantity;

            localStorage.setItem("orders", JSON.stringify(this.orders));
            this.store.commit("setOrders", this.orders);
        },
        decrement(idx) {
            this.orders[idx].quantity--;
            if (this.orders[idx].quantity === 0) {
                // alert('Negative quantity not allowed')
                var that = this;
                setTimeout(() => {
                    that.orders.splice(idx, 1);

                    localStorage.setItem(
                        "orders",
                        JSON.stringify(ththatis.orders)
                    );
                    that.store.commit("setOrders", that.orders);
                }, 1000);
            } else {
                this.orders[idx].sub_total =
                    this.orders[idx].unit_cost * this.orders[idx].quantity;

                localStorage.setItem("orders", JSON.stringify(this.orders));
                this.store.commit("setOrders", this.orders);
            }
        },
        validateAndUpdateQuantity(event, idx) {
          let value = parseInt(event.target.value);

          this.orders[idx].quantity = value;
          this.calculate(idx);
        },
        calculate(idx) {
            this.orders.forEach((data, index) => {
                data.sub_total =
                    parseFloat(data.quantity) * parseFloat(data.unit_cost);
            });

            var that = this;
            setTimeout(() => {
              if (this.orders[idx].quantity < this.minimumQuantity) {
                this.miscErrors = [`Minimum quantity per order is ${this.minimumQuantity}`];
                document.getElementById("misc_errors").scrollIntoView();
              }

                that.orders.forEach((data, idx) => {
                  data.sub_total = parseFloat(data.quantity) * parseFloat(data.unit_cost);
                });

                localStorage.setItem("orders", JSON.stringify(that.orders));
                that.store.commit("setOrders", that.orders);
            }, 1000);
        },
        removeItem(idx) {
            this.orders.splice(idx, 1);
            localStorage.setItem("orders", JSON.stringify(this.orders));
            this.store.commit("setOrders", this.orders);
        },
        payOrder() {
            this.showPaymentModal = true;
        },
        saveOrder(e) {


            this.showPaymentModal = false;

            const plist = this.dealerPriceLists.filter(
                (item) => item.id == this.selectedPriceList
            )[0];

            let buy_group_dates_id = null;
            if (plist != undefined) {
                buy_group_dates_id = plist.buy_group_dates_id;
            }

            // make sure orders without quantity are exluded
            let filteredOrders = this.getOrdersWithQuantity();

            let requestOrder = {
                location_id:
                    this.currentLocation.id == 0
                        ? this.selectedLocation.id
                        : this.currentLocation.id,
                po_number: this.po_number,
                order: filteredOrders,
                total_items: this.totalQuantity,
                total_cost: this.grandTotal,
                requested_delivery_date: new Date(
                    this.requestedDeliveryDate
                ).toLocaleDateString(),
                order_type: "create",
                shipping_fee: this.shippingFee,
                paymentData: this.paymentData,
                pricelist_id: this.selectedPriceList,
                buy_group_dates_id: buy_group_dates_id,
                transaction_id: e.transaction_id,
                // sales_rep_email: this.user.sales_rep.email
            };
            // this.submitOrder(requestOrder);

            // SAVE ORDER
            window.emitter.emit("changeLoaderStatus", true);
            axios.post("/api/submit-order", requestOrder).then((resp) => {
                let orderId = resp.data.order_id;
                this.$store.commit("setSelectedStatePriceList", null);

                if (this.thumbnail.length > 0) {
                    const formData = new FormData();
                    formData.append("attachments", this.thumbnail[0]);
                    formData.append("id", orderId);

                    // UPLOAD ATTACHMENT
                    axios
                        .post("/api/upload-order-attachment", formData)
                        .then((response) => {
                            // SEND ORDER EMAIL
                            requestOrder.order_id = orderId;
                            axios
                                .post("/api/send-order-email", requestOrder)
                                .then((response) => {
                                    this.store.dispatch("getAllOrders", {
                                        location_id: requestOrder.location_id,
                                    });
                                    window.emitter.emit(
                                        "changeLoaderStatus",
                                        false
                                    );
                                });
                        });
                } else {
                    // SEND ORDER EMAIL
                    requestOrder.order_id = orderId;
                    axios
                        .post("/api/send-order-email", requestOrder)
                        .then((response) => {
                            this.store.dispatch("getAllOrders", {
                                location_id: requestOrder.location_id,
                            });
                            window.emitter.emit("changeLoaderStatus", false);
                        });
                }

              localStorage.setItem("po_number", "");
              localStorage.setItem("orders", JSON.stringify([]));
              this.store.commit("setOrders", []);

              this.screen = 3;
            }).catch(({ response }) => {
                window.emitter.emit("changeLoaderStatus", false);
                this.screen = 1;
                this.miscErrors = [response.data.error];
                document.getElementById("misc_errors").scrollIntoView();
            });
        },
        backToDashboard() {
            this.$router.push({ name: "dashboard" });
        },
        reviewOrder() {
            if (this.orders?.length > 0) {
                return "";
            } else {
                return "disabled";
            }
        },
        savePO() {
            localStorage.setItem("po_number", this.po_number);
        },
        onChangeThumbnail(e) {
            // this.thumbnail = e.target.files;

            var myFile = e.target.files[0].name;
            var upld = myFile.split(".").pop();
            if (upld == "pdf") {
                // alert("File uploaded is pdf")
                this.thumbnail = e.target.files;
            } else {
                // alert("Only PDF are allowed")
                this.thumbnail = [];
                $("input[name=thumbnail]").val("");

                window.emitter.emit("alertSuccess", {
                    message: "Only PDF are allowed",
                    alertType: "error",
                });
            }
            // console.log('this.thumbnail', this.thumbnail)
        },
        generateURL(file) {
            let fileSrc = URL.createObjectURL(file);
            setTimeout(() => {
                URL.revokeObjectURL(fileSrc);
            }, 1000);
            return fileSrc;
        },
        handlePayment(data) {
            let isValidPayment = false;
            if (data.messages != undefined) {
                if (data.messages.resultCode == "Ok") {
                    isValidPayment = true;
                }
            }

            if (!isValidPayment) {
                this.showPaymentError = true;
                return;
            } else {
                this.paymentData = data;
                this.saveOrder();
            }
        },
        changePriceList() {

            this.$store
                .dispatch("getAllPricelists", {
                    pricelist_id: this.selectedPriceList,
                    location_id: !this.selectedLocation?.id ? this.currentLocation.id : this.selectedLocation.id,
                })
                .then((res) => {
                    let selectedPricelist = this.dealerPriceLists.filter(
                        (item) => item.id == this.selectedPriceList
                    )[0];

                    if (this.orders.length > 0) {
                        let tmpOrder = [];
                        for (let x = 0; x < this.orders.length; x++) {
                            let productIndex = this.pricelists.findIndex(
                                (item) => item.sku == this.orders[x].sku
                            );
                            if (productIndex >= 0) {
                                tmpOrder.push({
                                    id: this.pricelists[productIndex].id,
                                    sku: this.pricelists[productIndex].sku,
                                    product_name:
                                        this.pricelists[productIndex]
                                            .product_name,
                                    unit_cost:
                                        this.pricelists[productIndex].price,
                                    quantity: this.orders[x].quantity,
                                    sub_total:
                                        this.pricelists[productIndex].price *
                                        this.orders[x].quantity,
                                    available_quantity:
                                        this.pricelists[productIndex]
                                            .available_quantity,
                                });
                            }
                        }

                        this.orders = tmpOrder;
                        localStorage.setItem(
                            "orders",
                            JSON.stringify(this.orders)
                        );
                        this.store.commit("setOrders", this.orders);
                    } else {
                        if (selectedPricelist != undefined) {
                            if (selectedPricelist.require_all_items == 1) {
                                let tmpOrder = [];
                                this.pricelists.forEach((item) => {
                                    tmpOrder.push({
                                        id: item.id,
                                        sku: item.sku,
                                        product_name: item.product_name,
                                        unit_cost: item.price,
                                        quantity: 0,
                                        sub_total: item.price * 1,
                                        available_quantity:
                                            item.available_quantity,
                                    });
                                });

                                this.orders = tmpOrder;
                                localStorage.setItem(
                                    "orders",
                                    JSON.stringify(this.orders)
                                );
                                this.store.commit("setOrders", this.orders);
                            }
                        }
                    }

                    // add all items to cart for buy group pricelists
                    if (selectedPricelist.require_all_items == 1) {
                        if (selectedPricelist?.buy_group_dates_id != null) {
                            let orderSkus = [];
                            if (this.orders.length > 0) {
                                orderSkus = this.orders.map((item) => item.sku);
                            }
                            for (let x = 0; x < this.pricelists.length; x++) {
                                if (orderSkus.includes(this.pricelists[x].sku)) {
                                    continue;
                                }
                                this.orders.push({
                                    id: this.pricelists[x].id,
                                    sku: this.pricelists[x].sku,
                                    product_name: this.pricelists[x].product_name,
                                    unit_cost: this.pricelists[x].price,
                                    quantity: 0,
                                    sub_total: 0,
                                    available_quantity:
                                        this.pricelists[x].available_quantity,
                                });
                            }
                        } else {
                            // otherwise remove all line items without quantity
                            this.orders = this.getOrdersWithQuantity();
                        }
                    } else {
                        // otherwise remove all line items without quantity
                        this.orders = this.getOrdersWithQuantity();
                    }
                    
                });
        },
        buyDateValidation() {
            this.miscErrors = [];

            if (this.dealerPriceLists.length == 1) {
                return true;
            }

            // get the selected pricelist
            const plist = this.dealerPriceLists.filter(
                (item) => item.id == this.selectedPriceList
            )[0];

            let errors = [];

            // validate accessories minimum quantity (PER SKU)
            if (plist.accessories_minimum_quantity > 0) {
                for (let x = 0; x < this.orders.length; x++) {
                    if (
                        this.orders[x].sku.includes("AC") &&
                        this.orders[x].quantity <
                            plist.accessories_minimum_quantity &&
                        this.orders[x].quantity != 0
                    ) {
                        errors.push(
                            `A minimum quantity of ${plist.accessories_minimum_quantity} is required for each accessories.`
                        );
                        break;
                    }
                }
            }

            // validate suppressors minimum quantity
            if (plist.order_suppressor_minimum_quantity > 0) {
                let total_suppressor_qty = 0;
                for (let x = 0; x < this.orders.length; x++) {
                    if (this.orders[x].sku.includes("SU")) {
                        total_suppressor_qty += this.orders[x].quantity;
                    }
                }
                if (
                    total_suppressor_qty <
                    plist.order_suppressor_minimum_quantity
                ) {
                    if (
                        total_suppressor_qty == 0 &&
                        plist.accessories_minimum_quantity > 0 &&
                        this.totalAccessoryQty > 0
                    ) {
                    } else {
                        errors.push(
                            `A minimum total quantity of ${plist.order_suppressor_minimum_quantity} is required for the suppressors.`
                        );
                    }
                }
            }

            // validate item minimum quantity
            if (plist.minimum_quantity_per_item > 0) {
                let has_minimum_quantity = false;
                for (let x = 0; x < this.orders.length; x++) {
                    if (
                        this.orders[x].quantity >=
                        plist.minimum_quantity_per_item
                    ) {
                        has_minimum_quantity = true;
                    }
                    /*
                    if (
                        this.orders[x].quantity <
                        plist.minimum_quantity_per_item
                    ) {
                        errors.push(
                            `A minimum quantity of ${plist.minimum_quantity_per_item} is required for each item.`
                        );
                        break;
                    }
                    */
                }

                if (!has_minimum_quantity) {
                    errors.push(
                        `A minimum quantity of atleast ${plist.minimum_quantity_per_item} for one item is required.`
                    );
                }
            }

            if (plist.order_minimum > 0) {
                let total = this.grandTotal;
                if (total < plist.order_minimum) {
                    errors.push(
                        `A minimum total of ${plist.order_minimum} is required for this order.`
                    );
                }
            }

            if (plist.require_all_items > 0) {
                for (let x = 0; x < this.pricelists.length; x++) {
                    let idx = this.orders.findIndex(
                        (item) => item.id == this.pricelists[x].id
                    );
                    if (idx == -1) {
                        errors.push(
                            `All items in the price list are required for this order`
                        );
                        break;
                    }
                }
            }

            if (errors.length > 0) {
                this.miscErrors = errors;
                document.getElementById("misc_errors").scrollIntoView();
                return false;
            }

            return true;
        },
        getOrdersWithQuantity() {
            let filteredOrders = [];
            for (let x = 0; x < this.orders.length; x++) {
                if (this.orders[x].quantity > 0) {
                    filteredOrders.push(this.orders[x]);
                }
            }
            return filteredOrders;
        },
        selectLocation() {
            this.selectedPriceList = null;
            this.orders = [];
            localStorage.setItem("orders", JSON.stringify([]));
            this.store.commit("setOrders", []);
            // this.getDealerPriceLists(this.selectedLocation.id);

            this.hasFFLExpired = computed(() => {            
            if( moment(this.selectedLocation.ffl_expiry_date).isBefore(moment(), 'day') ){
                return true;
            } else {
                return false;
            }
            });

            this.formattedFFLExpiryDate = computed(() => {
                return moment(this.selectedLocation.ffl_expiry_date).format('MMM DD, YYYY');
            });


            this.store
                .dispatch("getDealerPriceLists", {
                    location_id: this.selectedLocation.id,
                })
                .then((resp) => {
                    if (this.dealerPriceLists.length == 1) {
                        this.$store
                            .dispatch("getAllPricelists", {
                                pricelist_id: this.selectedLocation.pricelist_id,
                                location_id: this.selectedLocation.id,
                            })
                    }
                });

            localStorage.setItem('is_selected_location_speq', this.selectedLocation?.is_speq);
        },

        getFreeShippingSettings() {
            axios.get("/api/free-shipping-settings").then((res) => {
                let data = res.data;
                this.accessory_free_shipping_amount =
                    data.accessory_free_shipping_amount;
                this.combined_free_shipping_amount =
                    data.combined_free_shipping_amount;
                this.suppressor_free_shipping_amount =
                    data.suppressor_free_shipping_amount;
            });
        },
    },
    watch: {
      selectedLocation: {
        handler(newLocation) {
        },
        immediate: true
      },
      isLocationSpeq: {
        handler(location) {
        },
        immediate: true
      }
    }
};
</script>
<style scoped>
.free-shipping-section {
    color: black;
    padding-top: 20px;
    padding-bottom: 20px;
    position: absolute;
    margin-left: 50%;
    width: 100%;
    /* top: -20px; */
}

.free-shipping-section.alt {
    color: black;
    padding-top: 20px;
    width: 100%;
    top: 10px;
    margin-left: unset;
    position: relative;
}
.free-shipping-section > strong {
    font-family: "TT-Norms-ExtraBold";
    font-size: 21px;
}
</style>
